import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.2",
  viewBox: "0 0 23.103 24.976"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M11.551 3.047a1 1 0 1 0 1 1 1 1 0 0 0-1-1ZM13.542 9.197a.249.249 0 1 1-.249.249.249.249 0 0 1 .249-.249M9.56 9.197a.249.249 0 1 1-.249.249.249.249 0 0 1 .249-.249M4.583 7.526a24.877 24.877 0 0 1 13.938 0M22.503 24.376v-3.093a1.967 1.967 0 0 0-.767-1.572c-1.324-1.014-4.48-2.8-10.185-2.8s-8.855 1.793-10.184 2.8A1.967 1.967 0 0 0 .6 21.283v3.092" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "m17.525 7.029-.878-4.391a1 1 0 0 0-.69-.759L11.837.643a1 1 0 0 0-.571 0l-4.12 1.236a1 1 0 0 0-.69.759l-.878 4.391v1.493a5.973 5.973 0 0 0 11.947 0ZM4.823 20.114a.5.5 0 0 0 .558.639l1.61-.269a.5.5 0 0 1 .579.494v.965a.5.5 0 0 0 .436.5l3.546.439A11.4 11.4 0 0 1 9.1 17.03a19.443 19.443 0 0 0-3.521.659Z" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M18.28 20.114a.5.5 0 0 1-.558.639l-2.189-.362v1.552a.5.5 0 0 1-.436.5l-3.546.44a11.4 11.4 0 0 0 2.452-5.852 19.442 19.442 0 0 1 3.521.659ZM11.551 22.878v1.5" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }